import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=524962d0&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('524962d0')) {
      api.createRecord('524962d0', component.options)
    } else {
      api.reload('524962d0', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=524962d0&", function () {
      api.rerender('524962d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eg3tNOmVeG0q/JS/comp/seasonprices.vue"
export default component.exports